/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Userstammdaten1Inputs */

const en__field_userstammdaten1 = /** @type {(inputs: _Field_Userstammdaten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`user data`)
};

const de__field_userstammdaten1 = /** @type {(inputs: _Field_Userstammdaten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer Daten`)
};

/**
* | output |
* | --- |
* | "user data" |
*
* @param {_Field_Userstammdaten1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_userstammdaten1 = /** @type {((inputs?: _Field_Userstammdaten1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Userstammdaten1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_userstammdaten1(inputs)
	return de__field_userstammdaten1(inputs)
});
export { _field_userstammdaten1 as "_field_userStammdaten" }